import React from 'react';
import { Button, Breadcrumb, BreadcrumbItem } from 'carbon-components-react';
import { Dialog, Slide } from '@material-ui/core';
import funcTranslateHelper from '../../../i18next/funcTranslateHelper';
import {
  BooleanFormControl,
  MultiSelectFormControl,
  SelectFormControl,
  RadioFormControl,
  TextFormControl,
  TextWithTagsFormControl,
  HiddenIdFormControl,
  SelectTextSubtypeControl,
  CustomObjectSubform
} from './FormControls';

import {
  CustomSubformSelectInput,
  CustomSubformTextInput,
  CustomSubformNumericInput,
  CustomDateInput
} from '../../Form/CustomComponents';

import {
  ArrayTemplate,
  RowTemplate,
  ErrorTemplate,
  ObjectTemplate
} from './Templates';
import Form from 'react-jsonschema-form';
import './FormStyles.css';

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction='down' ref={ref} {...props} />;
});

function BuilderForm ({
  onClose,
  onAdd,
  onEdit,
  open,
  title,
  subtitle,
  schema,
  uiSchema,
  Template,
  primaryButtonText,
  secondaryButtonText,
  formData,
  type
}) {
  let formCarbon;

  const onSubmit = !Object.entries(formData).length ? onAdd : onEdit;

  const fields = {
    Checkbox: BooleanFormControl,
    MultiSelect: MultiSelectFormControl,
    Select: SelectFormControl,
    Radio: RadioFormControl,
    TextInput: TextFormControl,
    TextInputWithTags: TextWithTagsFormControl,
    HiddenId: HiddenIdFormControl,
    SelectTextSubtype: SelectTextSubtypeControl,
    DateInput: CustomDateInput,
    // --------------------------------------------------
    customSubformSelectInput: CustomSubformSelectInput,
    customSubformTextInput: CustomSubformTextInput,
    customSubformNumericInput: CustomSubformNumericInput,
    // ---------------------------------------------------
    customObjectSubform: CustomObjectSubform
  };

  const ArrayTemplates = {
    Asset: ArrayTemplate,
    RowTemplate: RowTemplate
  };

  const ObjectTemplates = {
    ObjectAttribute: ObjectTemplate
  };

  return (
    <Dialog
      className='dialog-container'
      fullScreen
      onClose={onClose}
      open={open}
      TransitionComponent={Transition}
    >
      <div className='form-container'>
        <div className='form-top-container'>
          <Breadcrumb>
            <BreadcrumbItem href='#' onClick={onClose}>
              Viewer
            </BreadcrumbItem>
          </Breadcrumb>
          <div className='form-actions'>
            <div className='top-left'>
              <p className='form-title'>{funcTranslateHelper(title)}</p>
              <p className='form-title form-subtitle'>
                {funcTranslateHelper(subtitle)}
              </p>
            </div>
            <div className='top-right'>
              <Button
                className='form-button'
                kind='secondary'
                onClick={onClose}
                tabIndex={0}
              >
                {funcTranslateHelper(`${secondaryButtonText}`)}
              </Button>
              <Button
                className='form-button'
                kind='primary'
                tabIndex={1}
                onClick={() => formCarbon.submit()}
              >
                {funcTranslateHelper(`${primaryButtonText}`)}
              </Button>
            </div>
          </div>
        </div>
        <Form
          ref={(form) => {
            formCarbon = form;
          }}
          className='form-builder'
          schema={schema}
          uiSchema={uiSchema}
          fields={fields}
          ArrayFieldTemplate={Template ? ArrayTemplates[Template] : null}
          ObjectFieldTemplate={Template ? ObjectTemplates[Template] : null}
          ErrorList={ErrorTemplate}
          autoComplete='off'
          onSubmit={onSubmit}
          formData={formData}
          noHtml5Validate
        >
          <button type='submit' style={{ display: 'none' }} />
        </Form>
      </div>
    </Dialog>
  );
}

export default BuilderForm;
